//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import { Text } from 'platform-components';
import LessonMeta from 'platform-components/src/components/lesson-meta';
import React from 'react';
import { connect } from 'react-redux';

import withTime, { InjectedProps as WithNowProps } from 'common.components/timer/withTime';
import { getIsLessonEvaluable } from 'utils/lesson';

import * as selectors from '../selectors';

import './assignment__collapsed.scss';

interface HOCProps extends WithNowProps {}

interface StoreProps {
    assignDateValue: Date | null;
    deadlineDateValue: Date | null;
    lessonMode: CLESSON_MODES | null;
    duration: number | null;
}

export interface Props extends HOCProps, StoreProps {}

export const AssignmentCollapsedDate = (props: Props) => {
    //eslint-disable-line complexity
    const { assignDateValue, deadlineDateValue, lessonMode, duration } = props;

    const isEvaluable = getIsLessonEvaluable(lessonMode);

    return (
        <div className="assignment__dates-placeholder">
            <LessonMeta.Date endDate={deadlineDateValue} startDate={assignDateValue} />
            {isEvaluable && duration && (
                <div className="assignment__duration-placeholder">
                    <div className="assignment__placeholder-title">
                        <Text id="assignLessonModal.finalMode.duration" size={Text.SIZE.S} />
                    </div>
                    <Text id="assignLessonModal.finalMode.durationMinutes" values={{ duration }} />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (storeState: any, { now }: HOCProps): StoreProps => ({
    assignDateValue: selectors.getAssignDateValue(storeState, { now }),
    deadlineDateValue: selectors.getDeadlineDateValue(storeState, { now }),
    lessonMode: selectors.getLessonMode(storeState),
    duration: selectors.getDuration(storeState),
});

export default withTime(connect(mapStateToProps)(AssignmentCollapsedDate));
